import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export async function loadConfig() {
  const headers = getTokenHeader();
  try {
    const response = await axios.get(
      env.assistent_api_client_url + "configs/" + this.currentPrincipal,
      {
        headers
      }
    );
    this.config = response.data;
  } catch (error) {
    this.createError(error);
  }
}

export async function loadSeasons() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal
  };
  try {
    const response = await axios.get(
      env.assistent_api_client_url + "seasons/",
      {
        headers,
        params
      }
    );
    this.seasons = response.data;
    this.seasonsKey = this.seasonsKey ?? [];
    this.seasons.forEach(season => {
      if (season.is_current) {
        this.currentSeason = season._id;
      }
      this.seasonsKey[season._id] = season;

      //add vuetify-date (field not in db-structure)
      season.valid_thru_vuetifyDate = season.valid_thru
        ? season.valid_thru.substr(0, 10)
        : "";
    });
  } catch (error) {
    this.createError(error);
  }
}
export async function loadFormats() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal,
    by_group_id: "formats"
  };
  try {
    const response = await axios.get(
      env.assistent_api_client_url + "metadata/",
      {
        headers,
        params
      }
    );
    const formats = response.data;
    this.formats = formats.map(format => {
      return { title: format.values.title, value: format.values.title };
    });
  } catch (error) {
    this.createError(error);
  }
}

export async function loadMetadataGroups() {
  const headers = getTokenHeader();
  const params = {
    principal_id: this.currentPrincipal
  };
  try {
    const response = await axios.get(
      env.assistent_api_client_url + "metadata_groups/",
      {
        headers,
        params
      }
    );
    this.metadataGroups = response.data;
  } catch (error) {
    this.createError(error);
  }
}

export async function createError(error) {
  this.snackMessage(
    "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
    "#c55c52" //$main-red
  );
  console.error(error);
}

export async function snackMessage(msg, color = "#00636C") {
  this.snackbarText = msg;
  this.snackbarColor = color;
  this.snackbar = true;
}
